const listFormat = new Intl.ListFormat('en', {
  style: 'long',
  type: 'conjunction',
});

export default listFormat;
